import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/utils/auth";

const ADMIN_UID = "U4mlColHvRdwiA0q6jU13cuMExB3";

const ProtectedRoute = () => {
  const { user, loading } = useAuth();

  if (loading)
    return (
        <div
            style={{
              height: "100vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: "18px",
              fontWeight: "bold",
            }}
        >
          Loading...
        </div>
    );


  if (!user) {
    return <Navigate to="/auth/sign-in" replace />;
  }

  if (user.uid === ADMIN_UID) {
    return <Navigate to="/admin" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
